import { Button, Cell, FormControl, Grid } from 'bold-ui'
import { useAlert } from 'components/alert'
import { useErrorHandler } from 'components/error'
import { Form, FormRenderProps, TextField } from 'components/form'
import { useValidarChaveAutenticacaoMutation } from 'graphql/hooks.generated'
import React from 'react'
import { metaPath } from 'util/metaPath'
import { createValidator, maxLength, required } from 'util/validation'

import { EstadoCamposUnificacaoBase } from './ConfiguracoesUnificacaoBaseBox'
import { UnificarBasesChaveValidada } from './UnificarBasesChaveValidada'

export interface ValidacaoSenhaFormProps {
  conexaoInternet: boolean
  solicitacaoId: string
  estadoCamposForms: EstadoCamposUnificacaoBase
  setEstadoCamposForms(estadoCampos: EstadoCamposUnificacaoBase): void
}

export interface ValidacaoSenhaModel {
  senha?: string
}

export const validate = createValidator<ValidacaoSenhaModel>({
  senha: [required, maxLength(255)],
})

export const ValidacaoSenhaForm = (props: ValidacaoSenhaFormProps) => {
  const path = metaPath<ValidacaoSenhaModel>()
  const { conexaoInternet, solicitacaoId, estadoCamposForms, setEstadoCamposForms } = props
  const alert = useAlert()
  const handleRejection = useErrorHandler()
  const [validarChaveAutenticacao] = useValidarChaveAutenticacaoMutation()
  const handleOnSubmitClicked = (formProps) => {
    const { senha } = formProps
    if (!conexaoInternet) {
      alert(
        'warning',
        'Não é possível unificar a base sem conexão com a internet. Habilite a conexão ou tente novamente mais tarde.'
      )
    } else
      validarChaveAutenticacao({
        variables: { input: { solicitacaoId: solicitacaoId, chaveInstalacao: senha } },
      })
        .then(() => {
          setEstadoCamposForms({
            ...estadoCamposForms,
            isCampoSenhaAtivo: false,
            showBlocoInformativoUnificarBases: true,
          })
        })
        .catch(handleRejection)
  }

  const renderForm = (formProps: FormRenderProps<ValidacaoSenhaModel>) => {
    return (
      <Grid gap={1}>
        <Cell size={5}>
          <h4>2. Chave gerada pelo destinatário</h4>
        </Cell>
        <Cell size={7} />
        <Cell size={4}>
          <TextField
            name={path.senha}
            label='Chave'
            maxLength={255}
            required
            disabled={!estadoCamposForms?.isCampoSenhaAtivo}
          />
        </Cell>
        <Cell size={6}>
          <FormControl label={<span>&nbsp;</span>}>
            <Button
              size='small'
              kind='primary'
              onClick={formProps.handleSubmit}
              disabled={!estadoCamposForms?.isCampoSenhaAtivo}
            >
              Validar
            </Button>
          </FormControl>
        </Cell>
        {estadoCamposForms?.showBlocoInformativoUnificarBases && (
          <Cell size={6}>
            <UnificarBasesChaveValidada />
          </Cell>
        )}
      </Grid>
    )
  }
  return <Form<ValidacaoSenhaModel> render={renderForm} validate={validate} onSubmit={handleOnSubmitClicked} />
}
